import { useTranslation } from "react-i18next";

import { Box } from "@mui/material";

import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useEvercookieAdapter } from "../../../hooks";

import {
  BoxWrapper,
  Container,
  CustomSuBAndDescription,
} from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import AccordionTable from "../../../components/common/AccordionTable";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import { Button } from "../../../components/ui/Button/Button";
import useEvercookie from "./useEvercookie";

import { Section } from "../../../components/common/Section/Section.styled";
import { AccordionTableWrapper } from "./CheckEvercookie.styled";

const CheckEvercookie = () => {
  const { uid, generateEvercookie, convertToFieldArray } = useEvercookie();
  const data = convertToFieldArray(uid ? uid : "N/A");
  const { t } = useTranslation();

  const {
    headerData,
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
  } = useEvercookieAdapter();

  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          <BoxWrapper>
            <CustomSuBAndDescription
              sub={`UID = ${uid ? uid : t("evercookie.notSet")}`}
              desc={t("evercookie.description")}
            />
            <Box>
              <Button
                currentClass="primaryBtn"
                fullWidth
                onClick={generateEvercookie}
              >
                {t("evercookie.createEvercookieButton")}
              </Button>

              <AccordionTableWrapper>
                <AccordionTable
                  data={data}
                  headerData={headerData}
                  renderRowContent={renderRowContent}
                  renderDropdownContent={renderDropdownContent}
                  renderHeaderTitle={renderHeaderTitle}
                  showStatus={false}
                />
              </AccordionTableWrapper>
            </Box>
          </BoxWrapper>
        </Container>
      </Section>
      <Faq sectionType="innerTools" />
      <Seo sectionType="innerTools" />
    </>
  );
};

CheckEvercookie.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default CheckEvercookie;
